import { useEventDemographicsQuery } from './useDashboardQueries';
import AgeGroupStats from './AgeGroupStats';
import GeoStats from './GeoStats';
import RepeaterStats from './RepeaterStats';
import TrackingStats from './TrackingStats';
import UI from '../../common/UI';

export interface EventDemographicsDashboardPageProps {
  eventId: string;
}

const EventDemographicsDashboardPage = ({ eventId }: EventDemographicsDashboardPageProps) => {
  const { event } = useEventDemographicsQuery(eventId);

  if (!event) {
    return <UI.PageLoader />;
  }

  return (
    <>
      <UI.GridContainer sc={{ columns: ['1fr', '1fr 1fr'] }}>
        <RepeaterStats event={event} />
        <AgeGroupStats event={event} />
      </UI.GridContainer>
      <GeoStats event={event} />
      <TrackingStats event={event} />
    </>
  );
};

export default EventDemographicsDashboardPage;
